<template>
  <div class="about-us">
    <h1>关于我们</h1>
    <h2>
      公司简介：{{$company}}致力于陌生人婚恋服务领域多年，为广大单身男女提供安全、绿色、靠谱、稳定的婚恋平台。快速解决脱单难题。
    </h2>
    <p>
      {{$appName}}：{{$appName}}APP是一款同城附近、年轻人速配交流的婚恋软件。
    </p>
    <div>
      <p>产品特色</p>
      <ul>
        <li>【在线聊天】：在线实时邂逅，真实面对面，发现身边精彩；</li>
        <li>【同城婚恋】：邂逅身边缘分，快速搭讪约见面，简单高效；</li>
        <li>【缘分不断】：百万附近男女24小时在线，文字、图片、聊天。</li>
        <li>
          【在线精彩推荐】：一键定位，快速匹配附近的在线异性，认识有趣的灵魂。
        </li>
      </ul>
      <p>{{$appName}}，一款真人的婚恋app，你喜欢的都在这里。快来加入吧！！！</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.about-us {
  width: 59%;
  margin: 0 auto;
  font-size: 16px;
  color: #333;
  text-align: left;
  h1 {
    font-size: 20px;
    text-align: center;
    margin-bottom: 20px;
  }
  h2 {
    font-weight: normal;
    margin-bottom: 40px;
  }
  p {
    margin-bottom: 10px;
  }
  div {
    ul {
      margin-top: 10px;
      li {
        margin-bottom: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue